var React = require('react');

function ArrowTier (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.33309 3.05896L1.3335 3.14903","stroke":"#2D2927","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.13086 0.738647L9.33309 3.05899","stroke":"#2D2927","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.01318 5.26132L9.33339 3.05896","stroke":"#2D2927","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ArrowTier.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = ArrowTier;

ArrowTier.default = ArrowTier;
